<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="课程">
                    <el-input v-model="query.keyword" placeholder="请输入课程名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="学习时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    <el-button type="success" icon="el-icon-search" @click="refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="course_log_id" label="记录ID" width="80"></el-table-column>
                    <el-table-column prop="course" label="课程">
                        <template slot-scope="scope">
                            {{ scope.row.course ? scope.row.course.title : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="course" label="用户" width="180">
                        <template slot-scope="scope">
                            <el-image style="height: 40px" fit="contain" v-if="scope.row.user" class="ya-img-table" :src="scope.row.user.avatarUrl"
                                      :preview-src-list="[scope.row.user.avatarUrl]" title="点击查看大图" />
                            {{ scope.row.user ? scope.row.user.nickName : '' }}
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="" label="图片" width="100">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-image style="height: 40px" fit="contain" v-if="scope.row.file_path" class="ya-img-table" :src="scope.row.file_path"-->
<!--                                      :preview-src-list="[scope.row.file_path]" title="点击查看大图" />-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="course_type_desc" label="类型" width="100"></el-table-column>-->
<!--                    <el-table-column prop="category_desc" label="分类" width="100"></el-table-column>-->
<!--                    <el-table-column prop="status_desc" label="状态" width="100"></el-table-column>-->
<!--                    <el-table-column prop="sort" label="排序" width="60"></el-table-column>-->
                    <el-table-column prop="create_time" label="学习时间" width="150"></el-table-column>
<!--                    <el-table-column fixed="right" label="操作" width="130">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button @click="handleDetail(scope.row)" type="text" size="small" v-auth="'/education/course/detail'">详情</el-button>-->
<!--                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/course/add'">编辑</el-button>-->
<!--                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/course/del'">删除</el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { courseLog, courseDel } from '@/api/education';

    export default {
        components: {

        },
        props: {
          user: Number,
          default: 0,
        },
        watch:{
            'props.user': {
                handler (newName, oldName) {
                    if(newName === 'undefined'){
                        this.query.user_id = ''
                    }
                    this.query.user_id = newName
                },
                immediate: true
            }
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    user_id: '',
                    course_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            if(this.user > 0){
                //console.log(this.user, 'user_id')
                this.query.user_id = this.user
            }
            /*获取列表*/
            this.getTableList();
            //
            // if (this.$route.query.user_id != null) {
            //     this.query.user_id = this.$route.query.user_id
            // }

        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                courseLog(this.query).then((result)=>{
                    this.loading = false
                    this.select_type_array = result.data.select_type
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 详情
            // handleDetail(row){
            //     this.$refs['detail'].showDialog(row)
            // },
            // // 添加
            // handleAdd(){
            //     this.$refs['edit'].showDialog()
            // },
            // // 编辑
            // handleEdit(row) {
            //     this.$refs['edit'].showDialog(row)
            // },
            // 删除
            handleDelete(row) {
                if (row.course_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        courseDel({ids: row.course_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.course_type = val
            },
        }
    };
</script>

<style ></style>



// WEBPACK FOOTER //
// src/views/education/course/log/index.vue